import rcss from '../../../Styles/reports.module.css';
import { observer } from "mobx-react-lite";
import { enhancedContentSourceLocation } from "../../../lib/ContentSource";
import { SearchResultDetailsView } from "./common/SearchResultDetailsView";
import { SearchResultsObserver } from "../SearchResultsObserver";
import { CausationGraphObserver } from '../../../lib/Analysis/CausationGraphObserver';
import { InferredTypeNamesBlockView } from './common/InferredTypeNamesBlockView';
import { InteractiveRequestIdBaseProps } from '../InteractiveRequestId';
import { GetsDbEventsByIndex } from '../../../State/EvidenceDB/DbEventCache';
import { HasCallStackResolution } from '../../../lib/Causation/CallStackResolution';
import { Literal, SearchDetailsRenderOnFirstExpand } from '../../../Styles/ReportStyles';
import { HasLicensePermissions } from '../../../State/EvidenceDB/LicensePermissions';

export const SearchReportBySearchTermView = observer( ({
	searchResultsObserver,
	causationGraphObserver,
	...rest
}: {
	searchResultsObserver: SearchResultsObserver;
	causationGraphObserver?: CausationGraphObserver;
	getsDbEventsByIndex: GetsDbEventsByIndex;
} & InteractiveRequestIdBaseProps & HasCallStackResolution & HasLicensePermissions
) => {
	// ProcessInfo.log(`Rendering SearchReportBySearchTermView with ${searchResultsObserver.searchResultsBySearchTerm.length} terms` )
	return (<div className={rcss.report}>
		<h1>Data Exfiltrated</h1>
		{searchResultsObserver.searchResultsBySearchTerm.map(({ searchTerm, destinations }) => (
			<section className={rcss.reportSection} key={searchTerm}>
				<h2><Literal><span className={rcss.highlight}>{searchTerm}</span></Literal></h2>
				<div className={rcss.indented}>{destinations.map(({ destinationRegisteredDomain, sourcePages }) => sourcePages.map(({ sourceRegisteredDomain, encodings }) => (
					<div className={rcss.indented} key={`${searchTerm}\0${destinationRegisteredDomain}\0${sourceRegisteredDomain}`}>
						<h3>
							<Literal><span className={rcss.highlight}>{destinationRegisteredDomain}</span>&nbsp;⟵&nbsp;{sourceRegisteredDomain}</Literal>
						</h3>
						{encodings.map(({ encodingString, eventsAndResults, inferredTypeNames }) => (
							<div className={rcss.indented} key={encodingString}>
								<InferredTypeNamesBlockView inferredTypeNames={[...inferredTypeNames.keys()].sort()} />
								<SearchDetailsRenderOnFirstExpand key={encodingString} deferredRenderOnExpand={() => (<>{
									[...eventsAndResults.entries()]
									.sort( ([a], [b]) => a.localeCompare(b))
									.map(( [_, result]) => (
										<SearchResultDetailsView
											key={`${result.eventIndex}\0${result.searchResult.encodedSearchTerm}\0${result.searchResult.position}\0${enhancedContentSourceLocation(result.searchResult)}`}
											{...{result, causationGraphObserver, ...rest}} />
									))
								}</>)} >
									<summary>
										<span className={rcss.searchResultEncodingFoundSpan}>{encodingString}</span>&#32;found at…
									</summary>
								</SearchDetailsRenderOnFirstExpand>
							</div>
						))}
					</div>
				))
				).flat()}</div>
			</section>
		))}</div>);
	});
